function startOfLocalDay(date) {
  if (!date) return null;
  const day = new Date(date);
  if (Number.isNaN(day.getTime())) return null;
  day.setHours(0, 0, 0, 0);
  return day;
}

/**
 * react-datepicker selectsRange sets end equal to start when the same day is tapped twice.
 * A hotel stay needs checkout strictly after check-in. Same day or an earlier checkout
 * keeps check-in and clears check-out.
 * @param {Date|null|undefined} start
 * @param {Date|null|undefined} end
 * @returns {{ checkIn: Date|null, checkOut: Date|null }}
 */
export function applyHotelRangePick(start, end) {
  if (!start) return { checkIn: null, checkOut: null };
  if (!end) return { checkIn: start, checkOut: null };
  const checkInDay = startOfLocalDay(start);
  const checkOutDay = startOfLocalDay(end);
  if (!checkInDay || !checkOutDay || checkOutDay.getTime() <= checkInDay.getTime()) {
    return { checkIn: start, checkOut: null };
  }
  return { checkIn: start, checkOut: end };
}

/**
 * Check-in is today or later, and checkout is a later calendar day.
 * @param {Date|string|null|undefined} checkIn
 * @param {Date|string|null|undefined} checkOut
 * @param {Date} [today]
 * @returns {boolean}
 */
export function isHotelStayValid(checkIn, checkOut, today = new Date()) {
  const checkInDay = startOfLocalDay(checkIn);
  const checkOutDay = startOfLocalDay(checkOut);
  const todayDay = startOfLocalDay(today);
  if (!checkInDay || !checkOutDay || !todayDay) return false;
  return checkInDay.getTime() >= todayDay.getTime() && checkOutDay.getTime() > checkInDay.getTime();
}
